import Alert from 'react-s-alert';
import DealsService from '../utils/DealsService'
import history from '../history'

class DealActions {
  constructor(deal, handleDealUpdated, authStore) {
    this.deal = deal
    this.handleDealUpdated = handleDealUpdated
    this.authStore = authStore
  }

  handleDealUpdate = (response) => {
    if (this.handleDealUpdated) this.handleDealUpdated(response)
  }

  deleteDeal = async () => {
    const deal = this.deal
    DealsService.takeAction('delete_deal', deal.id, {}).then((response) => {
      Alert.success('Deal was scheduled to be deleted - it may take a minute')
      history.push('/m1/deals/list/open')
    })
  }
}
export default DealActions